<template>
    <vue-bottom-sheet ref="iconDetails">
        <div v-if="activeIcon"
             class="menu-item-icon-popup">
            <IconGluttenFreeOutline v-if="activeIcon.name === 'gluten-free'"
                                    width="40"
                                    height="40" />
            <IconPepperHot v-if="activeIcon.name === 'chili-pepper'"
                           width="40"
                           height="40" />
            <IconVegetarian v-if="activeIcon.name === 'vegeterian'"
                            width="40"
                            height="40" />
            <IconLowCal v-if="activeIcon.name === 'low-calories'"
                        width="40"
                        height="40" />
            <h2>{{ $t(activeIcon.name) }}</h2>
            <p>{{ $t(activeIcon.description) }}</p>
        </div>
    </vue-bottom-sheet>
</template>

<script>
import vueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import IconGluttenFreeOutline from '@/components/icons/IconGluttenFreeOutline.vue';
import IconPepperHot from '@/components/icons/IconPepperHot.vue';
import IconVegetarian from '@/components/icons/IconVegetarian.vue';
import IconLowCal from '@/components/icons/IconLowCal.vue';

export default {
    components: {
        vueBottomSheet,
        IconGluttenFreeOutline,
        IconPepperHot,
        IconVegetarian,
        IconLowCal,
    },
    props: {
        icon: { type: [String, null], default: null },
    },
    data() {
        return {
            iconsOptions: {
                "vegeterian": {
                    "name": "vegeterian",
                    "description": "vegeterian-description",
                },
                "gluten-free": {
                    "name": "gluten-free",
                    "description": "gluten-free-description",
                },
                "chili-pepper": {
                    "name": "chili-pepper",
                    "description": "chili-pepper-description",
                },
                "low-calories": {
                    "name": "low-calories",
                    "description": "low-calories-description",
                },
            },
            activeIcon: null,
        };
    },
    methods: {
        open() {
            this.activeIcon = this.iconsOptions[this.icon];
            this.$nextTick(() => {
                this.$refs.iconDetails.open();
            });
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .bottom-sheet__content {
    touch-action: none !important;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }
}

.menu-item-icon-popup {
    margin-bottom: 30px;
    padding: 0 30px 30px;

    text-align: center;
}
</style>